//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { db } from "/src/main.js";
import { analytics } from "/src/main.js";

export default {
  data() {
    return {
      socials: ["facebook", "instagram", "youtube", "website"],
      loaded: false,
      editMode: false,
      description: "",
    };
  },
  computed: {
    instructorKey() {
      return this.$route.params.uid;
    },
    instructor() {
      return this.loaded
        ? this.$store.state.instructors[this.instructorKey]
        : null;
    },
    classesByInstructor() {
      return this.loaded
        ? this.$store.state.classesArray.filter(
            (value) => value.instructor === this.instructorKey
          )
        : null;
    },
  },
  methods: {
    editDescription() {
      this.editMode = true;
    },
    saveDescription() {
      db.ref(`instructors/${this.instructorKey}/description`).set(
        this.description
      );
      this.editMode = false;
    },
  },
  async created() {
    await this.$store.dispatch("setClasses");
    await this.$store.dispatch("setInstructors");
    db.ref(`instructors/${this.instructorKey}`).on("value", () => {
      this.$store.dispatch("setInstructors");
    });
    this.loaded = true;
    this.description = this.instructor.description;
  },
  mounted() {
    var route = this.$route.path;
    analytics.logEvent("screen_view", {
      firebase_screen: `${route}`,
      firebase_screen_class: "screenClass",
    });
  },
};
